import { render, staticRenderFns } from "./GardensAll.vue?vue&type=template&id=f1924e0c"
import script from "./GardensAll.vue?vue&type=script&lang=js"
export * from "./GardensAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports